export const Experience = [
  {
    num: 0,
    id: 1,
    name: 'JavaScript',
    status: 'Udemy, Bootcamp-projects',
    description:
      'In the beginning, Udemy courses were handy to learn Front-end development which gave me an opportunity to make some interesting projects with the help of the instructor.',
  },
  {
    id: 2,
    name: 'Css and Sass',
    status: 'Udemy, Bootcamp-course',
    description:
      'During my journey in Web development, I realized that making responsive websites and awesome looking designs are important in this field, so dived deep into studying advanced styling on css and sass',
  },
  {
    num: 0,
    id: 3,
    name: 'React',
    status: 'Self-study',
    description:
      'As Web development is updating dramatically day by day, new handy and useful frameworks, libraries are being released to make better websites, so that to be aware of them, trying to do even small projects on it.',
  },
  {
    id: 4,
    name: 'GitHub',
    status: 'Team Work',
    description:
      'These days, I am participating in the projects like orderfood and houzing with the team via GitHub which is giving me an opportunity to gain communication and collaboration skills, alongside having a great experience!',
  },
  {
    num: 0,
    id: 5,
    name: "Bachelor's degree",
    status: 'Computer Engineering and IBBA (2017.09-2021.12)',
    description:
      "Graduated my bachelor's degree at Sejong university with GPA 3.5 out of 4.5",
  },
  {
    id: 6,
    name: 'Ilgungisa 1024',
    status: 'Front End developer (2022.01.01 - present)',
    description:
      'Currently working as front end developer at ilgungisa 1024 company, and helping to publish SEO friendly websites using nextjs and sass frameworks',
  },
  {
    num: 0,
    id: 7,
    name: "Master's degree",
    status: 'Computer science and engineering (2022.02 - present)',
    description:
      "Currently, I am pursuing a master's degree at Seoul National University of Science and Technology ",
  },
];
